import { isServer } from '@weberus/utils';
import { getYaNative } from '@yanolja-rnd/ya-native';

import type { YaNative } from '@yanolja-rnd/ya-native';

export type * from '@yanolja-rnd/ya-native/interfaces';
export const yaNative = isServer() ? ({} as YaNative) : getYaNative();
